import React from 'react';
import { hasFlag } from '../../Helper';
import { GraphicActionType, GraphicDirectoryInfo } from '../../model/GraphicModel';
import { useStoreSelector } from '../../store';
import { actionTypeSelector, graphicDataSelector } from '../../store/badge/selectors';
import { BadgeDirectory } from '../badge';
import { HeaderBar } from '../common';
import styles from './badge.module.scss';
import { BadgeDesigner } from './BadgeDesigner/BadgeDesigner';

const Badge: React.FC = () => {
	const graphicActionType: GraphicActionType = useStoreSelector<GraphicActionType>(actionTypeSelector);
	const graphicInfo: Partial<GraphicDirectoryInfo> = useStoreSelector(graphicDataSelector);

	return (
		<>
			{hasFlag(graphicActionType, GraphicActionType.Canvas) && (
				<>
					<HeaderBar title={graphicInfo?.Name} />
					<div className={styles.graphicComponentContainer}>
						<BadgeDesigner />
					</div>
				</>
			)}
			<div>
				{hasFlag(graphicActionType, GraphicActionType.Directory) || hasFlag(graphicActionType, GraphicActionType.ModalDirectory) ? (
					<BadgeDirectory isMaps={false} isModal={false} />
				) : null}
			</div>
		</>
	);
};

export { Badge };
